// extracted by mini-css-extract-plugin
export default {"mainContainer":"Style_mainContainer__nj5qw","tabPanel":"Style_tabPanel__CKzxR"};